module.exports = __webpack_public_path__ + "img/upper-deck-terrace-01.b17f1d75.jpeg";